export { Chat, UserAvatar, getUserFullName } from './Chat';
export { ChatInput } from './ChatInput';
export { ChatProvider } from './ChatProvider';
export { Messages } from './Messages';
export { IS_TYPING_EXPIRY, IS_TYPING_TIMEOUT, CHAT_MESSAGE_MAX_LENGTH } from './config';
export { useTypingStatus } from './hooks';
export { useChatEvents } from './useChatEvents';
export { useChatConnection, type ChatConnection } from './ChatConnection';
export { TicketListSkeleton } from './components/TicketListSkeleton';
export { EmptyTicketSelection } from './components/EmptyTicketSelection';
export { EmptyTicketList } from './components/EmptyTicketList';
export { TicketList } from './components/TicketList';
export { TicketListItem } from './components/TicketListItem';
export { TicketHeader } from './components/TicketHeader';
export { TicketsPageHeader } from './components/TicketsPageHeader';
export { TicketDetailsArea } from './components/TicketDetailsArea';

export type { ChatActions } from './Context';
export { ChatActionsNoop } from './Context';
import { ChatStatus, ChatType, type ChatUser, type ChatMeta } from '@duke-hq/svc-support/model';
export { ChatStatus, ChatType };

export type { ChatMeta, ChatUser };

const supportTypeMapping: Record<ChatType, string> = {
  [ChatType.General]: 'General Support',
  [ChatType.Assessment]: 'Assessment Support',
  [ChatType.Learning]: 'Learning Support',
  [ChatType.Caseload]: 'Caseload Support',
  [ChatType.ParticipantToProvider]: 'Participant to Provider Support',
};

export function getChatTypeText(supportType: ChatType): string {
  return supportTypeMapping[supportType];
}
